import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "DXA等級",
    isNumber: true,
    isSum: true,
  },
];

export const DXALevel = {
  label: "DXA等級(-1,-2.4)",
  key: "DXALevel",
  path: "BoneMuscleCare/DXALevel",
  api: "TCS_V_DXALevel02V",
  render: (options) => <Diagram.BoneMuscleCare.DXALevel {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "部位",
      field: "部位",
      header: "",
    },
  ],
  filterColumns: [{ key: "篩檢日期", type: "date" }],
  levelColumns,
  columns: [],
};
